/* eslint-disable prettier/prettier */
// import useSWR from 'swr';
import { NextSeo } from "next-seo";
import { motion } from "framer-motion";
// import { useRouter } from 'next/router';
import { styled } from "@stitches/react";
// import ReactPlayer from "react-player/lazy";
import { useEffect, useRef, useState } from "react";
import Head from "next/head";
import useAudioStore from "../../store/audio.store";
import useGuestCoverStore from "../../store/guestCover.store";
import { IndexMomentCover } from "../../modules/moment/layouts/IndexMomentCover";
import { IndexMomentDetail } from "../../modules/moment/layouts/IndexMomentDetail";
import { apiURL } from "../../utils/AppConfig.ts";

const Moment = ({ momentData, url, cover }) => {
  const audioRef = useRef(null);
  const playing = useAudioStore((state) => state.audioPlay);
  
  useEffect(() => {    
    // Make sure audioRef.current is not null before accessing play/pause methods
    if (audioRef.current) {
      if (playing) {
        audioRef.current.play();
      } else {
        audioRef.current.pause();
      }
    }
    
  }, [playing]);

  const guestCover = useGuestCoverStore((state) => state.guestCover);
  const data = momentData?.length > 0 ? momentData[0] : null;
  const logoBahagiaDay =
    "https://bahagia.s3.ap-southeast-3.amazonaws.com/dev/bahagia_default_image_0f97890872.jpg";

  const [showPage, setShowPage] = useState(null);

  const backsoundUrl = data?.backsound?.audioFile?.url;

  useEffect(() => {
    setShowPage(true);
  }, []);

  if (!data) {
    return (
      <div className="grid min-h-screen content-center">
        <div className="flex justify-center">
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
            className="text-center"
          >
            Tema Tidak Tersedia
          </motion.p>
        </div>
      </div>
    );
  }

  const comments = [
    {
      authorName: "Anissa",
      attendance: "will_attend",
      message:
        "Yaampun pasangan so sweet!!..... SAMAWA YAAA SAMPAI AKHIR HAYAT!! AAMIIN....",
    },
    {
      authorName: "Farel",
      attendance: "will_attend",
      message: "Selamat yaaa, semoga lancar sampai hari H!",
    },
    {
      authorName: "Tommy",
      attendance: "will_not_attend",
      message: "selamat yaaa, maaf tidak bisa hadir.",
    },
  ];

  return (
    <>
      <Head>
        <link rel="icon" href={logoBahagiaDay} />
      </Head>
      <NextSeo
        title={
          data?.coverStyle?.customName2
            ? `${data?.coverStyle?.customName} & ${data?.coverStyle?.customName2}`
            : data?.coverStyle?.customName || window.location.host
        }
        description={
          data?.coverStyle?.customName2
            ? `${data?.coverStyle?.title} ${data?.coverStyle?.customName} & ${data?.coverStyle?.customName2}`
            : `${data?.coverStyle?.title} ${data?.coverStyle?.customName}` ||
              `${data?.coverStyle?.title} ${window.location.host}`
        }
        canonical={url}
        openGraph={{
          url,
          title: data?.coverStyle?.customName2
            ? `${data?.coverStyle?.customName2} & ${data?.coverStyle?.customName}`
            : data?.coverStyle?.customName,
          description: `${data?.coverStyle?.title} ${data?.coverStyle?.customName}`,
          siteName: url || window.location.host,
          images: [
            {
              url:
                data?.coverStyle?.mainImage?.url ||
                data?.theme?.coverStyle?.mainImage?.url ||
                logoBahagiaDay,
              width: 800,
              height: 600,
              alt: "Og Image Alt",
              type: "image/jpeg",
            },
          ],
        }}
        twitter={{
          handle: "Bahagia.day",
          site: "Bahagia.day",
          cardType: "summary_large_image",
        }}
      />
      {showPage && (
        <>
          <audio
            ref={audioRef}
            src={
              backsoundUrl ??
              "https://res.cloudinary.com/dzrpqm8ab/video/upload/v1684817991/Raim_Komang_a63a529f03.mp3"
            }
            loop
            autoPlay
            controls={false}
          />

          {/* <ReactPlayer
            loop
            playing={playing}
            style={{ display: "none" }}
            pip={false}
            url={
              backsoundUrl ??
              "https://res.cloudinary.com/dzrpqm8ab/video/upload/v1684817991/Raim_Komang_a63a529f03.mp3"
            }
            config={{
              youtube: {
                playerVars: {
                  origin: "https://www.youtube.com",
                },
              },
            }}
          /> */}

          <div className="bg-white">
            {guestCover && cover !== "false" ? (
              <MainContainer>
                <IndexMomentCover
                  data={data}
                  isMomentActived={true}
                  isMomentThemeSampel={true}
                />
              </MainContainer>
            ) : (
              <MainContainer>
                <IndexMomentDetail
                  momentData={data}
                  isMomentThemeSampel={true}
                  comments={comments}
                />
              </MainContainer>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Moment;

const MainContainer = styled("div", {
  "min-height": "100vh",
  display: "flex",
  "justify-content": "center",
  "max-width": "500px",
  "min-width": "auto",
  margin: "auto auto",
  // backgroundColor: 'blue',
});

export const getServerSideProps = async (context) => {
  try {
    const slugUrl = context.query.slug;
    const urlParam = `filters[slugUrl]=${slugUrl}`;
    // Backsound
    const backsound = "populate[backsound][populate][0]=audioFile";

    // GlobalStyle
    const mainStyle = "populate[globalStyle][populate][mainStyle][populate]=*";
    const globalSectionStyle =
      "populate[globalStyle][populate][sectionStyle][populate]=*";
    const typography =
      "populate[globalStyle][populate][typography][populate]=*";
    const imageAttributes =
      "populate[globalStyle][populate][imageAttributes][populate]=*";

    const globalStylePopulate = `${mainStyle}&${globalSectionStyle}&${typography}&${imageAttributes}`;

    // Cover Style
    const coverStyleMainImage =
      "populate[coverStyle][populate][mainImage][fields][0]=url";
    const coverStyleBackgroundImage =
      "populate[coverStyle][populate][backgroundImage][populate][image][fields][0]=url";
    const coverStyleMainImageRounded = `populate[coverStyle][populate][mainImageRounded][populate]=*`;
    const coverPopulate = `${coverStyleMainImage}&${coverStyleBackgroundImage}&${coverStyleMainImageRounded}`;

    // Section
    const section = "populate[section][populate][content][populate]=*";
    const sectionImage = "populate[section][populate][image][populate]=*";
    const sectionStyle = "populate[section][populate][style][populate]=*";
    const sectionPopulate = `${section}&${sectionImage}&${sectionStyle}`;
    const allPopulation = `${backsound}&${globalStylePopulate}&${coverPopulate}&${sectionPopulate}`;
    const paramsKey = `${urlParam}&${allPopulation}`;
    const fetchURL = `${apiURL}/api/themes?${paramsKey}`;
    const response = await fetch(fetchURL, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${process.env.API_SECRET}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Error fetching data: ${response.status}`);
    }

    const dataRes = await response.json();
    const momentData = dataRes.data || null; // Set data to null if no data is available.

    return {
      props: {
        momentData,
        url: context.req.headers.host + context.req.url,
        cover: context.query.cover || "true",
      },
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error in getServerSideProps:", error);

    return {
      props: {
        momentData: null,
        url: context.req.headers.host + context.req.url,
        cover: context.query.cover || "true",
      },
    };
  }
};
